import z from "zod";
import { ProductTrackSchema } from "lib/misc/projectProducts";
import { RoofingNonrequestableReasonEnum, ProjectActionsProposalReasonEnum } from "rdx/modules/projects/enums";

export const CreateOverrideParamsSchema = z.object({
  projectId: z.number(),
  sellerPowurlinePpw: z.string(),
});

export const CloseProjectParamsSchema = z.object({
  projectId: z.number(),
  closeReasonId: z.number(),
  closeNote: z.string().optional(),
});

export const GetProjectActionsQueryParamsSchema = z.object({
  projectId: z.number(),
});

export const CreateOverrideResponseSchema = z.object({
  status: z.number(),
  body: z.object({}),
});

export const CloseProjectResponseSchema = z.object({
  status: z.number(),
  body: z.object({ id: z.number(), closeAt: z.string() }),
});

export const GetProjectActionsResponseSchema = z.object({
  availableActions: z.array(z.string()),
  reasons: z.object({
    solarNonrequestableReason: z.nativeEnum(ProjectActionsProposalReasonEnum).nullable(),
    batteryNonrequestableReason: z.nativeEnum(ProjectActionsProposalReasonEnum).nullable().optional(),
    roofingNonrequestableReason: z.nativeEnum(RoofingNonrequestableReasonEnum).nullable(),
  }),
  productTracks: z.array(ProductTrackSchema).optional(),
  batteryUpsellEligible: z.boolean().optional(),
  closeReasons: z.array(z.object({ id: z.number(), description: z.string(), order: z.number() })),
});

export {
  GetProjectProposalsParamsSchema,
  GetProjectProposalsResponseSchema,
  RenameProposalParamsSchema,
  RenameProposalResponseSchema,
  RequestRevisionParamsSchema,
  RequestRevisionResponseSchema,
  RequestVisionRevisionParamsSchema,
  RequestVisionRevisionResponseSchema,
  LinkAuroraDesignParamsSchema,
  LinkAuroraDesignResponseSchema,
  RefreshAuroraDesignParamsSchema,
  RefreshAuroraDesignResponseSchema,
  GetProposalDetailsParamsSchema,
  GetProposalDetailsResponseSchema,
  ProposalShowSchema,
} from "./schemas/projects/post-sales/proposals";
